import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.485 9.835A2.485 2.485 0 0 0 17.97 7.35V7.3a2.735 2.735 0 0 0-2.735-2.735h-6.2a.835.835 0 0 0 0 1.67h6.2c.588 0 1.065.477 1.065 1.065v.05c0 .45-.365.815-.815.815H4.935a.965.965 0 1 1 0-1.93h1.25a.835.835 0 1 0 0-1.67h-1.25a2.635 2.635 0 0 0 0 5.27h.411l-.662 1.83H2.335a.835.835 0 1 0 0 1.67H4.08l-.862 2.381a.754.754 0 0 0 .521 1.002.92.92 0 0 0 1.088-.566l1.02-2.817h8.362l1.02 2.817a.92.92 0 0 0 1.087.566.754.754 0 0 0 .521-1.002l-.861-2.38h1.859a.835.835 0 0 0 0-1.67h-2.464l-.662-1.83zm-2.519 0H7.09a.814.814 0 0 1-.043.184l-.596 1.646h7.155l-.595-1.646a.815.815 0 0 1-.044-.184",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }